import React, { useContext } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Cookie from "js-cookie";
import { Trash2 } from "lucide-react";
import { useSelector } from "react-redux";
import { UidContext } from "../App.Context";

/**
 * Suppression d'un compte.
 * - Page profil : cible lue dans l'URL.
 * - Tableau admin : `userId` passé en prop, `onDeleted` pour rafraîchir la liste.
 * On ne déconnecte (suppression du cookie + redirection) que si on supprime
 * son propre compte. `variant="inline"` rend un bouton compact (ds-btn).
 */
const ProfilDelete = ({ userId, onDeleted, variant = "default" }) => {
  const { id: paramId } = useParams();
  const uid = useContext(UidContext);
  const userData = useSelector((state) => state.userReducer);

  const targetId = `${userId ?? paramId ?? ""}`;
  const isSelf = uid + "" === targetId;
  const canDelete = userData.isAdmin === true || isSelf;
  if (!canDelete) return null;

  const handleDelete = async () => {
    if (!window.confirm("Voulez-vous supprimer le compte ?")) return;

    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_API_URL}/api/user/${targetId}`,
        withCredentials: true,
      });

      if (isSelf) {
        Cookie.remove("jwt", { expires: 1 });
        window.location = "/";
      } else if (onDeleted) {
        onDeleted();
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (variant === "inline") {
    return (
      <button className="ds-btn ds-btn--danger" onClick={handleDelete}>
        <Trash2 size={14} />
        Supprimer
      </button>
    );
  }

  return (
    <form
      className="input_media"
      onSubmit={(e) => {
        e.preventDefault();
        handleDelete();
      }}
    >
      <br />
      <input type="submit" className="submit" value="Supprimer le compte" />
    </form>
  );
};

export default ProfilDelete;
